<template>
  <span class="item-payment-dropdown" :class="{'item-payment-dropdown--show': isSchedulePaymentOpenProp}">
    <ul>
      <!-- Recurring payment -->
      <li class="item-payment-dropdown-headline">
        {{ $lang.messages.recurringPayments }}
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'ScheduleRecurringPaymentSpousalMaintenance', query:{ type: 'recurring' } }">
          {{ $lang.messages.spousalMaintenanceTitle }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'ScheduleRecurringPaymentChildMaintenance', query:{ type: 'recurring' } }">
          {{ $lang.messages.childMaintenanceTitle }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'ScheduleRecurringPaymentSharedExpenses', query:{ type: 'recurring' } }">
          {{ $lang.messages.sharedExpense }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>

      <!-- One-time payment -->
      <li class="item-payment-dropdown-headline">
        {{ $lang.messages.oneTimePayments }}
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'AddPaymentSpousalMaintenance', query: { type: 'onetime' } }">
          {{ $lang.messages.spousalMaintenanceTitle }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'AddPaymentChildMaintenance', query: { type: 'onetime' } }">
          {{ $lang.messages.childMaintenanceTitle }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>
      <li class="item-payment-dropdown-links" @click="chooseItem">
        <router-link :to="{ name: 'AddPaymentSharedExpenses', query: { type: 'onetime' } }">
          {{ $lang.messages.sharedExpense }}
        </router-link>
        <img src="@/assets/images/arrow_right.png" alt="Gray arrow icon">
      </li>
    </ul>
  </span>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { GET_PAYABLE_FROM } from "@/store/action.types";

  export default {
    computed: {
      ...mapGetters([
        'isAppLocked'
      ])
    },
    props: {
      isSchedulePaymentOpenProp: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      ...mapActions({
        GET_PAYABLE_FROM
      }),
      // When clicking on payment dropdown reset the active classes on Sidebar
      chooseItem () {
        this.$store.dispatch('GET_PAYABLE_FROM', false)
      }
    }
  }
</script>
